<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <div class="">
            <div class="h2">User management</div>
            <div class="">
                <div class="row">
                    <div class="col-md-12 mb-3">
                        <div @click="editableUser=null; toggleModal()"
                             class="btn btn-success float-right d-flex align-items-center"
                             title="Add new administrator">
                            <span class="material-icons-outlined cursor-pointer mr-1">post_add</span>
                            <span>Add new administrator</span>
                        </div>
                    </div>
                </div>

                <div class="position-relative pagination-control">
                    <data-table
                        :url="url"
                        :filters="filters"
                        :columns="columns"
                        :per-page="perPage"
                        :classes="classes"
                        :order-by="orderBy"
                        :order-dir="orderDir"
                        :meta="columns.meta"
                    >
                        <div slot="filters" slot-scope="{ tableFilters, perPage, users }">
                            <div class="row my-3 d-flex justify-content-end align-items-center">
                                <div class="col-md-3">
                                    <br/>
                                    <div
                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <button class="btn-sm bg-transparent border-0 d-flex align-items-center">
                                            <span class="material-icons-outlined cursor-pointer">search</span>
                                        </button>
                                        <input name="name" v-model="filters.search"
                                               class="form-control form-control border-0 py-0 pl-0 shadow-none form-input"
                                               placeholder="Search"/>
                                    </div>
                                </div>

                            </div>
                            <br/>
                        </div>
                        <thead class="clickable-header" slot="header" slot-scope="{ tableFilter }">
                        <tr>
                            <th>
                            </th>
                            <th @click="sort(column.id)" v-if="column.label!==''"
                                v-for="column in columns">
                                <span> {{ column.label }} </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody slot="body" slot-scope="{ data }">
                        <tr
                            :key="user.id"
                            v-for="(user,key) in data">
                            <td
                                :key="column.name"
                                v-for="column in columns"
                            >
                                <data-table-cell
                                    :value="user"
                                    :name="column.name"
                                    :meta="column.meta"
                                    :comp="column.component"
                                    :classes="column.classes">
                                </data-table-cell>

                                <slot v-if="column.label === ''">
                                    <input type="checkbox" :disabled="user.id==1 || user.id==4 || user.id==23"
                                           v-model="users[user.id]">
                                </slot>

                                <slot v-if="column.label === 'Edit'">
                                    <div @click="editableUser=user; toggleModal()">
                                        <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                    </div>
                                </slot>

                                <slot v-if="column.label === 'Terminal'">
                                    <select
                                        v-if="canManageTerminal"
                                        class="form-control form-control-sm"
                                        v-model="user.terminal_id"
                                        @focus="storeTerminalValue(user)"
                                        @change="updateTerminal(user)"
                                    >
                                        <option :value="null"></option>
                                        <option v-for="terminal in terminalOptions" :key="terminal.id" :value="terminal.id">
                                            {{ terminal.name }}
                                        </option>
                                    </select>
                                    <span v-else>{{ user.terminal_name || '' }}</span>
                                </slot>

                            </td>
                        </tr>
                        </tbody>
                    </data-table>
                </div>
                <br/>

                <button
                    @click="deleteUsers()"
                    class="btn  btn-sm btn-primary d-flex align-items-center float-left button-delete-location"
                    title="Delete user">
                                      <span class="material-icons-outlined cursor-pointer mr-1"
                                            title="delete">delete</span>
                    <span class="">Delete</span>
                </button>

            </div>
        </div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"> {{ editableUser ? 'update password' : 'Add new administrator' }} </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="editableUser=null; toggleModal()"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div v-if="!editableUser">
                            <form @submit.prevent="addNewUser">
                                <div class="form-group">
                                    <div
                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <input type="text"
                                               required
                                               autocomplete="none"
                                               class="form-control  border-0 py-0 shadow-none form-input"
                                               placeholder="Name"
                                               v-model="newUser.name"
                                        >
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div
                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <input type="text"
                                               required
                                               autocomplete="none"
                                               class="form-control  border-0 py-0 shadow-none form-input"
                                               placeholder="Email"
                                               v-model="newUser.email"
                                        >
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div
                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <input type="password"
                                               required
                                               autocomplete="none"
                                               class="form-control  border-0 py-0 shadow-none form-input"
                                               placeholder="Password"
                                               v-model="newUser.password"
                                        >
                                    </div>
                                </div>
                                <button class="btn btn-primary" @click="validation()">
                                    Save
                                </button>
                            </form>
                        </div>

                        <div v-else>
                            <form @submit.prevent="updateUser">
                                <div class="form-group">
                                    <strong> {{ editableUser.name }} </strong> <br/> <br/>

                                    <div
                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <input type="password"
                                               required
                                               autocomplete="none"
                                               class="form-control  border-0 py-0 shadow-none form-input"
                                               placeholder="New password"
                                               v-model="editableUser.password"
                                        >
                                    </div>
                                </div>
                                <button class="btn btn-primary" @click="validation()">
                                    Save
                                </button>
                            </form>
                        </div>




                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval" class="modal-backdrop fade show"></div>

    </div>
</template>

<script>
export default {
    name: "UserDataTable",
    props: {
        url: {type: String, required: true},
        terminalOptions: {type: Array, required: true},
        canManageTerminal: {type: Boolean, required: true},
    },
    data() {
        return {
            users: [],
            currentLocations: [],
            orderBy: 'id',
            orderDir: 'desc',
            search: '',
            perPage: [100, 10, 25, 50],
            filters: {
                search: '',
                length: 100,
                column: 'id',
                dir: 'desc',
            },
            loading: false,
            columns: [
                {
                    label: '',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'Name',
                    id: 'name',
                    name: 'name',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Email',
                    id: 'email',
                    name: 'email',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Terminal',
                    id: 'terminal',
                    orderable: false,
                    searchable: false,
                },
                {
                    label: 'Edit',
                    id: 'edit',
                    orderable: true,
                    searchable: true,
                },
            ],
            pagination: {
                align: "right",
                meta: {to: 1, from: 1}
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,
                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            selected: [],
            allSelected: false,
            activeModalInterval: false,
            show: false,
            isSubmit: false,
            newUser: {role: 'admin'},
            editableUser: null,
            previousTerminalValues: {},
        }
    },
    methods: {
        fetchData() {
            //
        },
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        validation() {
            this.isSubmit = true;
        },
        addNewUser: function () {
            axios.post(`/users`, this.newUser).then((response) => {
                this.flashMessage.success({
                    title: '',
                    message: 'success',
                    time: 2000,
                    blockClass: 'flash-message'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);

            }).catch(err => {
                alert('failed to create new user')
            })
        },
       updateUser: function () {
            axios.post(`/update-admin-password`, this.editableUser).then((response) => {
                this.flashMessage.success({
                    title: '',
                    message: 'success',
                    time: 2000,
                    blockClass: 'flash-message'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);

            }).catch(err => {
                alert('failed to create new user')
            })
        },
        storeTerminalValue(user) {
            this.$set(this.previousTerminalValues, user.id, user.terminal_id);
        },
        updateTerminal(user) {
            axios.patch(`/users/${user.id}/terminal`, {
                terminal_id: user.terminal_id
            }).then((response) => {
                user.terminal_id = response.data.terminal_id;
                user.terminal_name = response.data.terminal_name;
                this.flashMessage.success({
                    title: '',
                    message: 'success',
                    time: 2000,
                    blockClass: 'flash-message'
                });
            }).catch(() => {
                user.terminal_id = this.previousTerminalValues[user.id] ?? null;
                alert('failed to update terminal')
            })
        },
        deleteUsers() {
            if (confirm("Are you sure you want to delete selected users?")) {
                axios.post(`/delete-multiple-users`, this.users).then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'User(s) succesfully deleted',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }).catch(err => console.log(err))
            }

        },
    },
    created() {
        return this.fetchData()
    },
}
</script>

<style scoped>

</style>
